export const Urls = {
    RefreshSystemData: "voyage/RefreshSystemData",
    ComputeVoyageEmissions: "voyage/ComputeVoyageEmissions",
    ForceReporting: "voyage/ForceReporting",
    DownloadVoyageLegsAsExcel: "voyage/DownloadVoyageLegsAsExcel",
    GenerateExcelFiles: "voyage/GenerateExcelFiles",
    GetVoyageInfo: "voyage/GetVoyageInfo",
    GetCarbonAccountingSummaryReportData: "voyage/GetCarbonAccountingSummaryReportData",
    GetCarbonAccountingVoyageSubmissionYears: "voyage/GetCarbonAccountingVoyageSubmissionYears",
    GetVoyageIdsFromPortRoute: "voyage/GetVoyageIdsFromPortRoute",
    GetVoyageDeclaration: "voyage/GetVoyageDeclaration"
}